import t_12_2529 from './KZ.Т.12.2529 Syrdarya.svg'
import t_12_2529_b from './KZ.Т.12.2529 Syrdarya black.svg'

export default [
    t_12_2529,
    t_12_2529_b
]
